import { render, staticRenderFns } from "./UserDepartmentRegist.vue?vue&type=template&id=1bbf3b8b"
import script from "./UserDepartmentRegist.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserDepartmentRegist.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports